import _ from 'lodash'
export default {
  install(Vue) {
    // import( /* webpackChunkName: "lodash" */ 'lodash').then(_ => {
    //   // DO stuff
    //   Object.defineProperty(Vue.prototype, '_', {
    //     value: _.default
    //   })
    // })
    Object.defineProperty(Vue.prototype, '_', {
      value: _
    })
  }
}